import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.14.9_@types+react@19.3.0_next@15.5.27_@babel+core@7.29.7_@types+node@20.19.43_rea_67d5qkbxl2vtxwnoabq52eza24/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.27_@babel+core@7.29.7_@types+node@20.19.43_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/auth/auth-google-signin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthLoginFormComponent"] */ "/app/src/components/auth/auth-login-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalLangSwitcher"] */ "/app/src/components/language/language-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/src/components/ui/separator.tsx");
